import { MenuItem, Popover, Select, TextField } from '@mui/material';
import {
  CcfBox,
  CcfButton,
  CcfCloseIcon,
  CcfTextField,
  CcfTypography,
  CcfUpArrowIcon,
} from '@nice-ccf/ui-controls';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import styles from './ccf-voicemail-popover.module.scss';
import { updateActiveContact } from '@nice-ccf/ui-components';

/* eslint-disable-next-line */
export interface CcfVoicemailPopoverProps {
  anchorEl?: any;
  currentContact?: any;
  handleClose?: any;
  hideMediaControlClicked?: any;
  popoverFeature?: any;
}

/**
 *
 * @param props -
 * @example
 * @returns
 */
export function CcfVoicemailPopover(props: CcfVoicemailPopoverProps) {
  const dispatch = useDispatch();
  const [outboundPhoneNumber, setOutboundPhoneNumber] = useState('');
  const [outboundSkill, setOutboundSkill] = useState('');
  const [commitmentFirstName, setCommitmentFirstName] = useState('');
  const [commitmentLastName, setCommitmentLastName] = useState('');
  const [commitmentPhoneNumber, setCommitmentPhonenumber] = useState('');
  const [commitmentNotes, setCommitmentNotes] = useState('');
  const [commitmentOB, setCommitmentOB] = useState('Manual OB');
  const [commitmentTimezone, setCommitmentTimezone] = useState(
    '(GMT-07:00) Mountain Time'
  );

  /**
   * @example handleReset()
   */
  const handleReset = () => {
    setCommitmentFirstName('');
    setCommitmentLastName('');
    setCommitmentPhonenumber('');
    setCommitmentNotes('');
    setCommitmentOB('Manual OB');
    setCommitmentTimezone('(GMT-07:00) Mountain Time');
  };

  /**
   *
   * @param props -
   * @example
   * @returns
   */
  const startOutBoundCall = () => {
    props?.handleClose();
    dispatch(
      updateActiveContact({
        id: props?.currentContact?.id || '',
        updates: { outBoundCallStatus: true },
      })
    );
    props?.hideMediaControlClicked();
  };
  return (
    <Popover
      id={'voicemail-outbound-popover'}
      open={Boolean(props?.anchorEl)}
      keepMounted
      anchorEl={props?.anchorEl}
      onClose={props?.handleClose}
      anchorOrigin={{
        vertical: props?.popoverFeature === 'commitment' ? 'center' : 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: props?.popoverFeature === 'commitment' ? 'center' : 'top',
        horizontal: 'left',
      }}
      style={{
        marginLeft: props?.popoverFeature === 'commitment' ? '30px' : '0px',
      }}
    >
      {props?.popoverFeature === 'outBoundCall' ? (
        <CcfBox className={styles.outboundPopupContainer}>
          <CcfBox className={styles.headerSection}>
            <CcfTypography className={styles.headerTitle}>
              Callback
            </CcfTypography>
            <CcfCloseIcon
              className={styles.closeIcon}
              onClick={props?.handleClose}
            />
          </CcfBox>
          <CcfBox>
            <CcfTypography className={styles.labelTxt}>
              Phone Number
            </CcfTypography>
            <CcfTextField
              id="outboundPhoneNumber"
              variant="outlined"
              size="small"
              value={outboundPhoneNumber}
              focused={false}
              InputProps={{ className: styles.inputTxt }}
              onChange={(e: any) => {
                setOutboundPhoneNumber(e?.currentTarget?.value);
              }}
            />
          </CcfBox>
          <CcfBox marginTop={'20px'}>
            <CcfTypography className={styles.labelTxt}>Skill</CcfTypography>
            <Select
              displayEmpty
              name="skill"
              variant="outlined"
              className={styles.dropdown}
              value={outboundSkill}
              SelectDisplayProps={{
                style: { fontSize: '13px', color: '#333333' },
              }}
              sx={{
                "&& fieldset": {
                  border: "1px solid #c4c4c4"
                }
              }}
              IconComponent={() => (
                <CcfUpArrowIcon className={styles.arrowIconForDropdown} />
              )}
              onChange={(e: any) => {
                setOutboundSkill((e?.target as HTMLSelectElement).value);
              }}
            >
              <MenuItem value={'Angular'}>Angular</MenuItem>
              <MenuItem value={'React'}>React</MenuItem>
            </Select>
          </CcfBox>
          <CcfBox
            className={styles.BtnContainer}
            style={{
              cursor:
                outboundPhoneNumber && outboundSkill
                  ? 'pointer'
                  : 'not-allowed',
            }}
          >
            <CcfButton className={`${styles.btn} ${styles.CancelButton}`}>
              <CcfTypography
                className={`${styles.btnText} ${styles.txtCancel}`}
                onClick={props?.handleClose}
              >
                Cancel
              </CcfTypography>
            </CcfButton>
            <CcfButton
              className={`${styles.btn} ${styles.saveButton}`}
              disabled={!outboundPhoneNumber || !outboundSkill}
            >
              <CcfTypography
                onClick={startOutBoundCall}
                className={`${styles.btnText} ${styles.txtSave}`}
                style={{
                  color:
                    outboundPhoneNumber && outboundSkill
                      ? '#ffffff'
                      : '#003d78',
                }}
              >
                Call
              </CcfTypography>
            </CcfButton>
          </CcfBox>
        </CcfBox>
      ) : (
        <CcfBox className={styles.commitmentPopupContainer}>
          <CcfBox className={styles.headerSection}>
            <CcfTypography className={styles.headerTitle}>
              Schedule a Commitment
            </CcfTypography>
            <CcfCloseIcon
              className={styles.closeIcon}
              onClick={props?.handleClose}
            />
          </CcfBox>
          <CcfBox
            marginTop={'30px'}
            className={styles.commitmentPopupTxtFieldContainer}
          >
            <CcfTextField
              id="commitmentFirstName"
              variant="outlined"
              size="small"
              placeholder="First Name"
              InputProps={{ className: styles.inputTxt }}
              style={{ marginRight: '5px' }}
              focused={false}
              value={commitmentFirstName}
              onChange={(e: any) => {
                setCommitmentFirstName(e?.currentTarget?.value);
              }}
            />
            <CcfTextField
              id="commitmentLastName"
              variant="outlined"
              size="small"
              placeholder="Last Name"
              InputProps={{ className: styles.inputTxt }}
              style={{ marginLeft: '5px' }}
              focused={false}
              value={commitmentLastName}
              onChange={(e: any) => {
                setCommitmentLastName(e?.currentTarget?.value);
              }}
            />
          </CcfBox>
          <CcfBox marginTop={'10px'}>
            <CcfTextField
              id="commitmentPhoneNumber"
              variant="outlined"
              size="small"
              placeholder="Phone Number"
              fullWidth
              InputProps={{ className: styles.inputTxt }}
              focused={false}
              value={commitmentPhoneNumber}
              onChange={(e: any) => {
                setCommitmentPhonenumber(e?.currentTarget?.value);
              }}
            />
          </CcfBox>
          <CcfBox className={styles.BtnContainer}>
            <CcfBox>
              <CcfTypography className={styles.scheduleTxt}>
                Schedule
              </CcfTypography>
            </CcfBox>
            <CcfBox display={'flex'}>
              <CcfButton className={`${styles.btn} ${styles.meButton}`} primary>
                <CcfTypography
                  className={`${styles.btnText} ${styles.txtSave}`}
                >
                  Me
                </CcfTypography>
              </CcfButton>
              <CcfButton className={`${styles.btn} ${styles.skillButton}`}>
                <CcfTypography
                  className={`${styles.btnText} ${styles.txtCancel}`}
                >
                  Skill
                </CcfTypography>
              </CcfButton>
            </CcfBox>
          </CcfBox>
          <CcfBox marginTop={'10px'}>
            <Select
              displayEmpty
              name="skill"
              variant="outlined"
              className={styles.dropdown}
              SelectDisplayProps={{
                style: { fontSize: '12px', color: '#333333' },
              }}
              value={commitmentOB}
              sx={{
                "&& fieldset": {
                  border: "1px solid #c4c4c4"
                }
              }}
              IconComponent={() => (
                <CcfUpArrowIcon className={styles.arrowIconForDropdown} />
              )}
              onChange={(e: any) => {
                setCommitmentOB((e?.target as HTMLSelectElement).value);
              }}
            >
              <MenuItem value={'Manual OB'}>Manual OB</MenuItem>
              <MenuItem value={'Automatic OB'}>Automatic OB</MenuItem>
            </Select>
          </CcfBox>
          <CcfBox marginTop={'10px'}>
            <Select
              displayEmpty
              name="skill"
              variant="outlined"
              className={styles.dropdown}
              SelectDisplayProps={{
                style: { fontSize: '12px', color: '#333333' },
              }}
              value={commitmentTimezone}
              sx={{
                "&& fieldset": {
                  border: "1px solid #c4c4c4"
                }
              }}
              IconComponent={() => (
                <CcfUpArrowIcon className={styles.arrowIconForDropdown} />
              )}
              onChange={(e: any) => {
                setCommitmentTimezone((e?.target as HTMLSelectElement).value);
              }}
            >
              <MenuItem value={'(GMT-07:00) Mountain Time'}>
                (GMT-07:00) Mountain Time
              </MenuItem>
              <MenuItem value={'(GMT-05:00) Eastern Time'}>
                (GMT-05:00) Eastern Time
              </MenuItem>
            </Select>
          </CcfBox>
          <CcfBox marginTop={'10px'}>
            <CcfTextField
              id="commitmentNotes"
              fullWidth
              variant="outlined"
              multiline
              rows={3}
              maxRows={3}
              autoFocus={false}
              placeholder="Notes"
              InputProps={{ className: styles.inputTxt }}
              focused={false}
              value={commitmentNotes}
              onChange={(e: any) => {
                setCommitmentNotes(e?.currentTarget?.value);
              }}
            />
          </CcfBox>
          <CcfBox className={styles.commitmentPopupBtnContainer}>
            <CcfButton
              className={`${styles.btn} ${styles.CancelButton}`}
              style={{ marginRight: '10px' }}
              onClick={handleReset}
            >
              <CcfTypography
                className={`${styles.btnText} ${styles.txtCancel}`}
              >
                Reset
              </CcfTypography>
            </CcfButton>
            <CcfButton
              primary
              className={`${styles.btn} ${styles.saveButton}`}
              onClick={props?.handleClose}
            >
              <CcfTypography className={`${styles.btnText} ${styles.txtSave}`}>
                Save
              </CcfTypography>
            </CcfButton>
          </CcfBox>
        </CcfBox>
      )}
    </Popover>
  );
}

export default CcfVoicemailPopover;
